export default "__VITE_ASSET__B0mZ7LlP__"